import { type UseQueryResult, useQuery } from 'react-query';
import {
  PoolService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Pool_PoolDto,
} from '../../services/wealthlane-award-services';

const useGetSharePoolById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Pool_PoolDto | undefined,
  unknown
> => {
  const sharePoolById = useQuery(
    ['getSharePoolById'],
    async () => {
      if (id) {
        return await handleRequest(PoolService.getApiAwardApiAppPoolPoolById(id));
      }
    }
    // {
    //   enabled: !(id.length === 0),
    // }
  );

  return sharePoolById;
};

export default useGetSharePoolById;
